import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { getTelegramInitData } from './utils/telegramInitData';

// Новый backend принимает пользовательские запросы Mini App только вместе с
// подписанными Telegram initData. Добавляем их ко всем запросам собственного
// API централизованно, чтобы старые компоненты не дублировали этот код.
const nativeFetch = window.fetch.bind(window);
// Telegram Android may clear the SDK field after the first bootstrap tick.
// Preserve the signed launch payload once so every API request in this WebView
// carries the same server-verifiable identity.
const telegramInitDataAtLaunch = getTelegramInitData();
window.fetch = (input, options = {}) => {
    const requestUrl = new URL(
        typeof input === 'string' ? input : input.url,
        window.location.href
    );

    if (requestUrl.origin !== window.location.origin || !requestUrl.pathname.startsWith('/api/')) {
        return nativeFetch(input, options);
    }

    const headers = new Headers(input instanceof Request ? input.headers : undefined);
    new Headers(options.headers || {}).forEach((value, key) => headers.set(key, value));
    const telegramInitData = getTelegramInitData() || telegramInitDataAtLaunch;
    if (telegramInitData) {
        // Mini App identity is the signed Telegram launch, never a JWT left
        // in localStorage by an earlier browser session on the same device.
        headers.delete('Authorization');
        headers.set('X-Telegram-Init-Data', telegramInitData);
    }

    return nativeFetch(input, { ...options, headers });
};


if (process.env.NODE_ENV === 'development') {
    console.log('Development mode - proxy should be active');
    console.log('API requests to /api/* will be proxied to http://localhost:3001');
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
